import { render, staticRenderFns } from "./CampaignMemberPointLedger.vue?vue&type=template&id=720fb208&scoped=true"
import script from "./CampaignMemberPointLedger.vue?vue&type=script&lang=js"
export * from "./CampaignMemberPointLedger.vue?vue&type=script&lang=js"
import style0 from "./CampaignMemberPointLedger.vue?vue&type=style&index=0&id=720fb208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720fb208",
  null
  
)

export default component.exports